import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import FirstGlobalSection from '../components/home/FirstGlobalSection';
import MissionSection from '../components/home/MissionSection';
import SupportSection from '../components/home/SupportSection';
import VideoSection from '../components/home/VideoSection';
import RankingsSection from '../components/home/RankingsSection';
import HighlightsSection from '../components/home/HighlightsSection';
import SponsorsSection from '../components/home/SponsorsSection';
import SelectionSection from '../components/home/SelectionSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <FirstGlobalSection />
        <MissionSection />
        <SupportSection />
        <VideoSection />
        <RankingsSection />
        <HighlightsSection />
        <SponsorsSection />
        <SelectionSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
